// import moment from 'moment-timezone'
import moment from 'moment'

moment.locale('pt-BR')
